// Distinct in-app alert sounds (Web Audio — no asset files). A crystalline three-note shimmer for
// notifications and a warm rising two-note for messages, so managers and staff can tell them apart.
let ctx = null;

function ensure() {
  if (typeof window === "undefined") return null;
  try {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    return ctx;
  } catch {
    return null;
  }
}

// Browsers block audio until a user gesture — unlock the context on the first interaction.
export function unlockAudio() { ensure(); }
if (typeof window !== "undefined") {
  const u = () => ensure();
  ["pointerdown", "keydown", "touchstart"].forEach((e) => window.addEventListener(e, u, { once: true, passive: true }));
}

function tone(c, freq, start, dur, peak, type = "sine") {
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, start);
  g.gain.setValueAtTime(0.0001, start);
  g.gain.linearRampToValueAtTime(peak, start + 0.015);
  g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  o.connect(g);
  g.connect(c.destination);
  o.start(start);
  o.stop(start + dur + 0.03);
}

export function playChime(kind = "notification") {
  // Respect the user's alert-sound preference (Settings): off = silent; volume 0..1 scales loudness.
  try {
    if (localStorage.getItem("si_sound_off") === "1") return;
  } catch { /* ignore */ }
  let vol = 1;
  try {
    const v = parseFloat(localStorage.getItem("si_sound_vol"));
    if (!Number.isNaN(v)) vol = Math.min(1, Math.max(0, v));
  } catch { /* ignore */ }
  if (vol <= 0) return;
  const c = ensure();
  if (!c) return;
  const t = c.currentTime + 0.01;
  if (kind === "message") {
    tone(c, 587.33, t, 0.20, 0.16 * vol);        // D5
    tone(c, 880.00, t + 0.12, 0.30, 0.14 * vol); // A5
  } else {
    tone(c, 783.99, t, 0.16, 0.13 * vol);        // G5
    tone(c, 1046.50, t + 0.10, 0.16, 0.11 * vol);// C6
    tone(c, 1318.51, t + 0.20, 0.34, 0.09 * vol);// E6
  }
}
